import React from 'react'
import styled from 'styled-components'

import BackgroundImage from 'gatsby-background-image'
import useFluidImage from '../hooks/useFluidImage'

const BackgroundSection = ({ className, fileName }) => {
  const image = useFluidImage(fileName)
  if (!image) return null

  return <BackgroundImage Tag="div" className={className} fluid={image} />
}

const StyledBackgroundSection = styled(BackgroundSection)`
  width: 100%;
  background-position: bottom center;
  background-repeat: repeat-y;
  background-size: cover;
`

export default StyledBackgroundSection
